import React from 'react'
import { Typography } from '@mui/material'
import formatDateTime from '../../../utils/formatDateTime'
import type { Contact, SearchContactLog, UserAttributes } from '../generated/graphql'

interface CreatedByInfoProps {
    row?: Contact | SearchContactLog | null
    users?: (UserAttributes | null)[] | null
    isVisible?: boolean
}

export const CreatedByInfo: React.FC<CreatedByInfoProps> = ({ row, isVisible = false }) => {
    if (!isVisible) {
        return null
    }

    const creatorName = row?.creatorFullName ?? 'Unknown'
    let creationDateValue: string | undefined
    if (row) {
        if ('createdAt' in row && row.createdAt != null) {
            creationDateValue = row.createdAt
        } else if ('contactedAt' in row && row.contactedAt != null) {
            creationDateValue = row.contactedAt
        }
    }
    const creationDate = creationDateValue ? new Date(creationDateValue) : undefined
    const formattedDate = formatDateTime(true, creationDate) // true for full year format

    return (
        <div style={{ marginTop: '16px', paddingTop: '16px', borderTop: '1px solid #e0e0e0' }}>
            <Typography variant="body2" color="text.secondary">
                Created by {creatorName} on {formattedDate}
            </Typography>
        </div>
    )
}
